"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _formik = require("formik");

var _FieldGroup = _interopRequireDefault(require("../FieldGroup"));

var _File = require("../File");

var _Form = require("../../Ui/Form");

var _AckField = _interopRequireDefault(require("../../Ui/Form/AckField"));

var _Input = require("../../Ui/Form/Input");

var _Radio = require("../../Ui/Form/Radio");

var _CountrySelect = require("../../Ui/Select/CountrySelect");

var _helpers = require("./helpers");

var __jsx = _react["default"].createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Remove some of the unneeded attributes from the default field,
// so only the properties of `field` that are element attributes are passed as such
function getAttributesFromField(field) {
  var schema = field.schema,
      dataTestid = field.dataTestid,
      value = field.value,
      visibilityCondition = field.visibilityCondition,
      formatDisplay = field.formatDisplay,
      parseValueToAPI = field.parseValueToAPI,
      parseValueFromAPI = field.parseValueFromAPI,
      maskSecret = field.maskSecret,
      nameKey = field.nameKey,
      required = field.required,
      rest = (0, _objectWithoutProperties2["default"])(field, ["schema", "dataTestid", "value", "visibilityCondition", "formatDisplay", "parseValueToAPI", "parseValueFromAPI", "maskSecret", "nameKey", "required"]);
  var displayLabel = field.displayLabel || !!field.readOnly;
  return _objectSpread(_objectSpread(_objectSpread({}, rest), displayLabel !== undefined ? {
    displayLabel: displayLabel
  } : {}), required ? {
    'aria-required': true
  } : {});
}

var RenderFields = function RenderFields(_ref) {
  var fields = _ref.fields,
      defaultValues = _ref.defaultValues,
      biggerMargin = _ref.biggerMargin,
      onFilesRemoved = _ref.onFilesRemoved,
      setFieldValue = _ref.setFieldValue,
      formValues = _ref.formValues;

  function renderDefaultInput(field) {
    var attributes = getAttributesFromField(field);
    return __jsx(_Form.InputField, (0, _extends2["default"])({}, attributes, {
      id: field.name,
      "data-testid": field.dataTestid
    }));
  }

  function renderTextarea(field) {
    var attributes = getAttributesFromField(field);
    return __jsx(_Form.TextareaField, (0, _extends2["default"])({}, attributes, {
      id: field.name,
      "data-testid": field.dataTestid
    }));
  }

  function renderHidden(field) {
    var attributes = getAttributesFromField(field);
    return __jsx(_Form.HiddenField, (0, _extends2["default"])({}, attributes, {
      id: field.name,
      "data-testid": field.dataTestid
    }));
  }

  function renderDatePicker(field) {
    var attributes = getAttributesFromField(field);
    return __jsx(_Form.DatePickerField, (0, _extends2["default"])({}, attributes, {
      id: field.name,
      "data-testid": field.dataTestid
    }));
  }

  function renderSelect(_ref2) {
    var options = _ref2.options,
        field = (0, _objectWithoutProperties2["default"])(_ref2, ["options"]);
    var dynamicOptions = typeof options === 'function' ? options({
      formValues: formValues
    }) : options;
    var attributes = getAttributesFromField(_objectSpread(_objectSpread({}, field), {}, {
      options: dynamicOptions
    }));
    return __jsx(_Form.SelectField, (0, _extends2["default"])({}, attributes, {
      id: field.name,
      "data-testid": field.dataTestid
    }));
  }

  function renderCountriesSelect(field, setValue) {
    var _getAttributesFromFie = getAttributesFromField(field),
        onChange = _getAttributesFromFie.onChange,
        attributes = (0, _objectWithoutProperties2["default"])(_getAttributesFromFie, ["onChange"]);

    var handleChange = onChange ? function (selectedOption, meta, previousValue) {
      onChange({
        selectedOption: selectedOption,
        meta: meta,
        previousValue: previousValue,
        setValue: setValue,
        formValues: formValues
      });
    } : undefined;
    return __jsx(_CountrySelect.CountrySelectField, (0, _extends2["default"])({}, attributes, {
      id: field.name,
      "data-testid": field.dataTestid
    }, handleChange ? {
      onChange: handleChange
    } : {}));
  }

  function renderAckCheck(field) {
    var _getAttributesFromFie2 = getAttributesFromField(field),
        displayLabel = _getAttributesFromFie2.displayLabel,
        attributes = (0, _objectWithoutProperties2["default"])(_getAttributesFromFie2, ["displayLabel"]);

    return __jsx(_AckField["default"], (0, _extends2["default"])({}, attributes, {
      id: field.name,
      "data-testid": field.dataTestid
    }));
  }

  function renderMask(field) {
    // Remove some of the unneeded attributes from the default field,
    // so only the properties of `field` that are element attributes are passed as such
    var schema = field.schema,
        dataTestid = field.dataTestid,
        value = field.value,
        visibilityCondition = field.visibilityCondition,
        formatDisplay = field.formatDisplay,
        mask = field.mask,
        maskPlaceholder = field.maskPlaceholder,
        rest = (0, _objectWithoutProperties2["default"])(field, ["schema", "dataTestid", "value", "visibilityCondition", "formatDisplay", "mask", "maskPlaceholder"]);
    return __jsx(_Form.MaskedInputField, (0, _extends2["default"])({}, rest, {
      id: field.name,
      "data-testid": field.dataTestid,
      mask: mask,
      maskPlaceholder: maskPlaceholder
    }));
  }

  function renderFilePicker(field) {
    var attributes = getAttributesFromField(field);
    return __jsx(_File.FileUploadField, (0, _extends2["default"])({}, attributes, {
      key: field.name,
      name: field.name,
      id: field.name,
      "data-testid": field.dataTestid,
      files: defaultValues[field.name],
      onFilesRemoved: onFilesRemoved
    }));
  }

  function renderRadio(field) {
    var attributes = getAttributesFromField(field);
    return __jsx(_Radio.RadioField, (0, _extends2["default"])({}, attributes, {
      direction: field.direction || 'row',
      id: field.name,
      "data-testid": field.dataTestid
    }));
  }

  function renderRadioCard(field) {
    var attributes = getAttributesFromField(field);
    return __jsx(_Radio.RadioCardGroup, (0, _extends2["default"])({}, attributes, {
      name: field.name,
      "data-testid": field.dataTestid
    }), field.options.map(function (item, index) {
      return __jsx(_Radio.RadioCard, (0, _extends2["default"])({
        key: index,
        id: item.id,
        label: item.label || null,
        description: item.description || null,
        name: field.name,
        value: item.value,
        size: item.size || 'lg',
        variant: item.variant
      }, item));
    }));
  } // used to render components other than form fields


  function renderExtra(field) {
    var Component = field.Component,
        formatDisplay = field.formatDisplay,
        rest = (0, _objectWithoutProperties2["default"])(field, ["Component", "formatDisplay"]);
    return __jsx(Component, rest);
  }

  function renderGroupArray(group, setValue, renderFunction) {
    var _group$loopCondition, _group$loopCondition2;

    var groupCount = (_group$loopCondition = (_group$loopCondition2 = group.loopCondition) === null || _group$loopCondition2 === void 0 ? void 0 : _group$loopCondition2.call(group, formValues)) !== null && _group$loopCondition !== void 0 ? _group$loopCondition : 1;
    return __jsx(_formik.FieldArray, null, function () {
      return (0, _toConsumableArray2["default"])(Array(groupCount)).map(function (val, index) {
        return __jsx(_FieldGroup["default"], {
          key: "".concat(group.label, "-").concat(index),
          label: group.label
        }, group.fields(index).map(function (nestedField) {
          return __jsx(_Input.InputController, {
            key: nestedField.name
          }, renderFunction(nestedField, setValue, nestedField.name));
        }));
      });
    });
  }

  function renderMoney(field) {
    var attributes = getAttributesFromField(field);
    return __jsx(_Form.CurrencyInputField, (0, _extends2["default"])({}, attributes, {
      id: field.name,
      "data-testid": field.dataTestid
    }));
  }

  function getRenderedComponent(_ref3, setValue) {
    var type = _ref3.type,
        input = (0, _objectWithoutProperties2["default"])(_ref3, ["type"]);

    switch (type) {
      case _helpers.supportedTypes.SELECT:
        return renderSelect(input);

      case _helpers.supportedTypes.MASK:
        return renderMask(input);

      case _helpers.supportedTypes.COUNTRIES:
        return renderCountriesSelect(input, setValue);

      case _helpers.supportedTypes.FILE:
        return renderFilePicker(input);

      case _helpers.supportedTypes.RADIO:
        return renderRadio(input);

      case _helpers.supportedTypes.RADIO_CARD:
        return renderRadioCard(input);

      case _helpers.supportedTypes.EXTRA:
        return renderExtra(input);

      case _helpers.supportedTypes.GROUP_ARRAY:
        return renderGroupArray(input, setValue, getRenderedComponent);

      case _helpers.supportedTypes.MONEY:
        return renderMoney(input);

      case _helpers.supportedTypes.TEXTAREA:
        return renderTextarea(input);

      case _helpers.supportedTypes.HIDDEN:
        return renderHidden(input);

      case _helpers.supportedTypes.DATE:
        return renderDatePicker(input);

      case _helpers.supportedTypes.ACK_CHECK:
        return renderAckCheck(input);

      default:
        return renderDefaultInput(_objectSpread(_objectSpread({}, input), {}, {
          type: type
        }));
    }
  }

  function renderFields(inputs, inputValues, setValue) {
    return inputs.map(function (input) {
      var isFieldVisible = input.visibilityCondition ? input.visibilityCondition(inputValues) : true;

      if (isFieldVisible) {
        return __jsx(_Input.InputController, {
          key: input.name,
          biggerMargin: biggerMargin
        }, getRenderedComponent(input, setValue));
      }

      return null;
    });
  }

  return __jsx(_react["default"].Fragment, null, renderFields(fields, formValues, setFieldValue));
};

RenderFields.defaultProps = {
  defaultValues: {},
  biggerMargin: false
};
var _default = RenderFields;
exports["default"] = _default;